import  {useEffect, useState} from 'react'
import {DspData} from './AdminDashboardByDsp';
import ReactEcharts from 'echarts-for-react';

interface Props {
    data: DspData[],
    style: {},
    dsp
}

const BarChartByDsp = (props: Props) => {

    const [option, setOption] = useState<any>()

    useEffect(() => {
        loadOptions()
    }, [props.dsp, props.data])

    const loadOptions = () => {

        let bidData: any[] = []
        let winData: any[] = []
        let impData: any[] = []
        let dspData: any[] = []
        let viewData: any[] = []
        let clickData: any[] = []
        let vastStartData: any[] = []
        let vastCompleteData: any[] = []

        if (props.dsp) {
            props.data.forEach(d => {
                if (d.name === props.dsp) {
                    dspData.push({value: d.name})
                    bidData.push({value: d.bid});
                    winData.push({value: d.win})
                    impData.push({value: d.impression})
                    viewData.push({value: d.view})
                    clickData.push({value: d.click})
                    vastStartData.push({value: d.vastStart})
                    vastCompleteData.push({value: d.vastComplete})
                }
            });
        } else {
            bidData[0] = 0
            winData[0] = 0
            impData[0] = 0
            viewData[0] = 0
            clickData[0] = 0
            vastStartData[0] = 0
            vastCompleteData[0] = 0
            dspData[0] = 'Total'
            props.data.forEach(d => {
                bidData[0] += Number.parseInt(d.bid)
                winData[0] += Number.parseInt(d.win)
                impData[0] += Number.parseInt(d.impression)
                viewData[0] += Number.parseInt(d.view)
                clickData[0] += Number.parseInt(d.click)
                vastStartData[0] += Number.parseInt(d.vastStart)
                vastCompleteData[0] += Number.parseInt(d.vastComplete)
            });
        }

        const chartOption = {
            title: {
                text: 'Events',
                subtext: 'by Dsp',
                // textStyle: {fontSize: 'auto'},
                left: 'left'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                type: 'scroll',
                top: '6%',
                left: 'center'
            },
            grid: {
                top: '12%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    axisLabel: {
                        interval: 0,
                        // rotate: 45
                    },
                    data: dspData
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    nameTextStyle: {
                        padding: [0, 0, 0, -10],
                        align: 'left',
                    }

                },
                {
                    name: 'price',
                    type: 'value',
                    show: false
                }
            ],
            series: [
                {
                    name: 'Bid',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: bidData
                },
                {
                    name: 'Win',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: winData
                },
                {
                    name: 'Impression',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: impData
                },
                {
                    name: 'View',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: viewData
                },
                {
                    name: 'Click',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: clickData
                },
                {
                    name: 'VastStart',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: vastStartData
                },
                {
                    name: 'VastComplete',
                    type: 'bar',
                    barMaxWidth: 40,
                    yAxisIndex: 0,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        formatter: '{a} - {c}',
                        rotate: 90,
                        align: 'left',
                        verticalAlign: 'middle',
                        position: 'insideBottom',
                        distance: 15,
                        fontSize: 16
                    },
                    data: vastCompleteData
                }
            ]
        }
        setOption(chartOption)

    }

    return  <div>
                {option && <ReactEcharts style={props.style} option={option}/>}
            </div>
}

export default BarChartByDsp
